import StaffInput from "../widgets/StaffInput";
import StaffDisplay from "../widgets/StaffDisplay";
import TextInput from "../widgets/TextInput";
import Selection from "../widgets/Selection";
import Group from "../widgets/Group";
import Labeling from "../widgets/Labeling";
import SharpsOrderInput from "../widgets/SharpsOrderInput";
import ScoreAnnotationWidget from "../widgets/ScoreAnnotationWidget";
import RhythmCountWidget from "../widgets/RhythmCountWidget";
import MissingRhythmWidget from "../widgets/MissingRhythmWidget";
import DrawBarlinesWidget from "../widgets/DrawBarlinesWidget";
import TimeSigWidget from "../widgets/TimeSigWidget";
import MatchingWidget from "../widgets/MatchingWidget";
import SumMatchingWidget from "../widgets/SumMatchingWidget";
import BinaryChoiceWidget from "../widgets/eartrainingWidgets/BinaryChoiceWidget";
import SimpleBinary from "../widgets/eartrainingWidgets/SimpleBinary";
import MelodyEditor from "../widgets/MelodyEditor";
import LinearCircleOfFifthsWidget from "../widgets/LinearCircleOfFifths";
import GrandStaffInput from "../widgets/GrandStaffInput";
import ImageMultipleChoice from "../widgets/ImageMultipleChoice";
import TextInputWidget from "../widgets/TextInputWidget";
import EarInterval from "../widgets/eartrainingWidgets/EarInterval";
import KeySignatureInput from "../widgets/KeySignatureInput";
import BeamingWidget from "../widgets/BeamingWidget";
import MultiText from "../widgets/MultiTextInput";
import AudioText from "../widgets/AudioText";
import SectionDivider from "../widgets/SectionDivider";
import RhythmLine from "../widgets/RhythmLine";
import RhythmLineComposeBeaming from "../widgets/RhythmLineComposeBeaming";
import RelMmWidget from "../widgets/RelMmWidget";
import MajorTriadSpellWidget from "../widgets/MajorTriadSpell";
import GrandStaffKeySignatureInputWidget from "../widgets/GrandStaffKeySignatureInput";
import MelodyEditorSS from "../widgets/MelodyCompositionStaffSetup";
import BeatValueWidget from "../widgets/BeatValue";
import HalfWholeStepsWidget from "../widgets/HalfWholeBlanks";
import KeySignatureMatchWidget from "../widgets/KeySigMatch";
import ImageChoiceWidget from "../widgets/ImageChoiceWidget";
import TwoColumnImageChoiceWidget from "../widgets/TwoColumnImageChoice";
import CompleteTriadByEarWidget from "../widgets/CompleteTriadByEar";
import FifthLetterWidget from "../widgets/FifthLetter";
import KeyboardLetterFillWidget from "../widgets/KeyboardLetterFill";
import TwoBlankWidget from "../widgets/FillInBlanks";
import ImageAnswer from "../widgets/ImageAnswer";
import SymbolMatchingWidget from "../widgets/SymbolMatchingWidget";

//WORLD OF MUSIC
import WorldSection from "../widgets/WOM/WorldSection";

export const widgetMap = {
  "symbol-matching": SymbolMatchingWidget,
  "image-answer": ImageAnswer,
  "staff-fill-in-blanks": TwoBlankWidget,
  "keyboard-letter-fill": KeyboardLetterFillWidget,
  "fifth-letter": FifthLetterWidget,
  "complete-triad-by-ear": CompleteTriadByEarWidget,
  "two-column-image-choice": TwoColumnImageChoiceWidget,
  "image-choice": ImageChoiceWidget,
  "key-sig-match": KeySignatureMatchWidget,
  "half-whole-steps": HalfWholeStepsWidget,
  "beat-value": BeatValueWidget,
  "section-divider": SectionDivider,
  "audiotext": AudioText,
  "multitext": MultiText,
  "beaming": BeamingWidget,
  "key-signature": KeySignatureInput,
  "gs-key-signature": GrandStaffKeySignatureInputWidget,
  "ear-interval": EarInterval,
  "text-input": TextInputWidget,
  "image-multiple-choice": ImageMultipleChoice,
  "bonus-cof": LinearCircleOfFifthsWidget,
  "melody-input": MelodyEditor,
  "melody-composition": MelodyEditor,
  "melody-transposition": MelodyEditor,
  "melody-transposition-ss": MelodyEditorSS,
  "simple-binary": SimpleBinary,
  "binary-choice": BinaryChoiceWidget,
  "sum-matching": SumMatchingWidget,
  "matching": MatchingWidget,
  "input-timesig": TimeSigWidget,
  "draw-barlines": DrawBarlinesWidget,
  "missing-rhythm": MissingRhythmWidget,
  "rhythm-count": RhythmCountWidget,
  "score-annotation": ScoreAnnotationWidget,
  "staff-input": StaffInput,
  "staff-display": StaffDisplay,
  "text": TextInput,
  "selection": Selection,
  "group": Group,
  "diagram-labeling": Labeling,
  "sharps-order": SharpsOrderInput,
  "grand-staff": GrandStaffInput,
  "rhythm-line": RhythmLine,
  "rhythm-line-compose-beaming": RhythmLineComposeBeaming,
  "rel-maj-min": RelMmWidget,
  "major-triad-spell": MajorTriadSpellWidget,

  //WOM
  "world-section": WorldSection,
};
